/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_SubmitInputs */

const tr_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajı gönder`)
};

const en_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send message`)
};

const de_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht senden`)
};

const ru_contact_form_submit = /** @type {(inputs: Contact_Form_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить сообщение`)
};

/**
* | output |
* | --- |
* | "Send message" |
*
* @param {Contact_Form_SubmitInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_submit = /** @type {((inputs?: Contact_Form_SubmitInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_SubmitInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_submit(inputs)
	if (locale === "de") return de_contact_form_submit(inputs)
	if (locale === "ru") return ru_contact_form_submit(inputs)
	return tr_contact_form_submit(inputs)
});